"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const GA_SCRIPT_URL = 'https://www.ikea.com/se/sv/analytics/scripts/analytics-minor.min.js';
const TYPE = 'text/javascript';
/**
 * Utility class for loading the INGKA GA script, necessary for setting up Google Analytics.
 */
class GAScriptLoader {
    /**
     * Check if the GA script is already loaded, and constructs and loads it if not.
     *
     * @returns The Promise from {@link constructScriptElement}, or an autoresolved Promise if already loaded.
     */
    loadGoogleAnalyticsScript() {
        return __awaiter(this, void 0, void 0, function* () {
            let scriptLoaded = false;
            const scripts = document.getElementsByTagName('script');
            // Loop through all script tags
            Array.from(scripts).forEach(script => {
                if (script.src && script.src === GA_SCRIPT_URL && script.type && script.type === TYPE) {
                    scriptLoaded = true;
                }
            });
            if (!scriptLoaded) {
                try {
                    yield this.constructScriptElement();
                    return Promise.resolve();
                }
                catch (e) {
                    return Promise.reject(e);
                }
            }
            return Promise.resolve();
        });
    }
    /**
     * Construct the script element, and appends it to document.head.
     *
     * @returns A promise for loading the script.
     */
    constructScriptElement() {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = GA_SCRIPT_URL;
            script.type = TYPE;
            script.async = true;
            document.head.appendChild(script);
            script.addEventListener('load', () => {
                resolve(script);
            });
            script.addEventListener('error', () => {
                reject(new Error(`${GA_SCRIPT_URL} failed to load.`));
            });
        });
    }
}
exports.default = GAScriptLoader;
//# sourceMappingURL=GAScriptLoader.js.map